import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { CareerValuationCategoryValue } from "@common/ADAPT.Common.Model/organisation/career-valuation-category-value";
import { Autobind } from "@common/lib/autobind.decorator/autobind.decorator";
import { BaseComponent } from "@common/ux/base.component/base.component";
import { OrgCommonCareerValuationUiService } from "../org-common-career-valuation-ui.service";

@Component({
    selector: "adapt-cvt-category-value",
    templateUrl: "./cvt-category-value.component.html",
    styleUrl: "./cvt-category-value.component.css",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class CareerValuationCategoryValueComponent extends BaseComponent implements OnChanges {
    @Input() public categoryValue!: CareerValuationCategoryValue;

    public indicatorColor?: string;

    public constructor(
        public careerValuationUiService: OrgCommonCareerValuationUiService,
    ) {
        super();
    }

    public ngOnChanges(changes: SimpleChanges) {
        if (changes.categoryValue) {
            this.indicatorColor = this.careerValuationUiService.getCategoryColour(this.categoryValue.category);
        }
    }

    @Autobind
    public getCustomText() {
        return this.categoryValue.actualValue + " / " + this.categoryValue.idealValue;
    }
}
